<template>
  <b-modal
      @hidden='displayTab = true; cleanForm()'
      ref="add-kanban-be-modal"
      hide-footer
      title="Création de cartes Kanban BE"
      size="lg"
  >
    <div class="d-block">
      <b-container fluid>
        <div class="tab" v-if="currentTab == 1"> 
          <b-row>
            <b-col sm="3">
              <label> Entreprise :</label>
            </b-col>
            <b-col sm="9">
              <b-form-input
                type="text"
                v-model="form.plant"
                :state="!isEmpty(form.plant)"
                placeholder="ex: AIO"
                :formatter="formatter">
              </b-form-input>
            </b-col>
          </b-row>
          <br>
          <b-row v-if="displayTab">
            <b-col sm="3">
              <label>Type d'affaire :</label>
            </b-col>
            <b-col sm="9">
              <b-form-group>
                <b-form-radio-group
                  id="btn-radios-2"
                  v-model="form.selectedType"
                  :options="options"
                  buttons
                  button-variant="outline-primary"
                  size="md"
                  @change="typeChanged"
                  name="radio-btn-outline"
                ></b-form-radio-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row >
            <b-col sm="3"></b-col>
            <b-col sm="6">
              <b-form-input 
                v-if="form.selectedType=='kanban'"
                type="text"
                minlength="7"
                maxlength="7"
                v-model="form.case_type"
                :state="!isEmpty(form.case_type)"
                placeholder="ex: 1234567"
              ></b-form-input>
            </b-col>
            <b-col sm="3">
              <b-form-input
                v-if="form.selectedType=='kanban'"
                type="text"
                minlength="3"
                maxlength="3"
                v-model="form.case_line"
                :state="!isEmpty(form.case_line)"
                placeholder="ex: A01"
                :formatter="formatter"
              ></b-form-input>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col sm="3">
              <label>Client :</label>
            </b-col>
            <b-col sm="9">
              <b-form-input type="text" v-model="form.customer" placeholder="ex: Mr Arthur Mit"></b-form-input>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col sm="3">
              <label>Type de commande :</label>
            </b-col>
            <b-col sm="9">
              <b-form-select v-model="form.command_type" :options="command_type_options" :state="!isEmpty(form.command_type)"></b-form-select>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col sm="3">
              <label>Domaine :</label>
            </b-col>
            <b-col sm="9">
              <b-form-select v-model="form.domain" :options="domain_options" :state="!isEmpty(form.domain)"></b-form-select>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col sm="3">
              <label>Descriptif :</label>
            </b-col>
            <b-col sm="9">
              <b-form-textarea v-model="form.descriptif" rows="2" max-rows="2" placeholder="ex: Chariot intercalaires " maxlength="150"></b-form-textarea>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col sm="3">
              <label>Détail :</label>
            </b-col>
            <b-col sm="9">
              <b-form-textarea v-model="form.details" rows="2" max-rows="2"  maxlength="150"></b-form-textarea>
            </b-col>
          </b-row>
          <br>
        </div>

        <div class="tab" v-if="currentTab == 2">
          <b-row>
            <b-col sm="4">
              <label>Client interne :</label>
            </b-col>
            <b-col sm="8">
              <b-form-input type="text" v-model="form.internal_customer" minlength="4" maxlength="4" :state="!isEmpty(form.internal_customer)" :formatter="formatter" placeholder="AMIT"></b-form-input>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col sm="4">
              <label>Fournisseur interne :</label>
            </b-col>
            <b-col sm="8">
              <b-form-input type="text" v-model="form.internal_supplier" minlength="4" maxlength="4" :state="!isEmpty(form.internal_supplier)" :formatter="formatter" placeholder="AMIT"></b-form-input>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col sm="4">
              <label>Marguerite :</label>
            </b-col>
            <b-col sm="8">
              <b-form-input type="text" v-model="form.daisy"></b-form-input>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col sm="4">
              <label>Date de commande :</label>
            </b-col>
            <b-col sm="8">
              <b-form-input type="date" v-model="form.command_date"></b-form-input>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col sm="4">
              <label>Date de rendu :</label>
            </b-col>
            <b-col sm="8">
              <b-form-input type="date" v-model="form.delay_ask" ></b-form-input>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col sm="4">
              <label>Charge estimée (jours):</label>
            </b-col>
            <b-col sm="8">
              <b-form-input type="number" step="0.05" min="0" v-model="form.estimated_workload" placeholder="ex : 0,5"></b-form-input>
            </b-col>
          </b-row>
        </div>
        <hr>
        <div style="overflow:auto;">
          <div style="float:right;">
            <b-button
              v-if="currentTab !== 1"
              class="mt-3"
              variant="outline-secondary"
              id="prevBtn" 
              @click="prevTab()"
            >
              Précédent
            </b-button>
            <b-button 
              v-if="this.currentTab < this.nbFormParts"
              class="mt-3"
              variant="info"
              id="nextBtn"
              :disabled="(this.isEmpty(this.form.plant) || this.isEmpty(this.form.domain) || this.isEmpty(this.form.command_type))"
              @click="nextTab()"
            >
              Suivant
            </b-button>
            <b-button
              v-if="this.currentTab >= this.nbFormParts"
              class="mt-3"
              variant="info"
              id="nextBtn"
              :disabled="(this.isEmpty(this.form.internal_supplier) || this.isEmpty(this.form.internal_customer))"
              @click="save()"
            >
              Enregistrer
            </b-button>
            <b-button
              v-if="this.currentTab >= this.nbFormParts"
              class="mt-3"
              variant="info"
              id="saveAndDo"
              :disabled="(this.isEmpty(this.form.internal_supplier) || this.isEmpty(this.form.internal_customer))"
              @click="saveAndDoItAgain()"
            >
              Enregistrer et recommencer
            </b-button>
          </div>
        </div>
        <div style="text-align:center;margin-top:20px;">
          <span class="step" v-bind:class="[{ active: currentTab == 1}, { finish: currentTab == 2}]"></span>
          <span class="step" v-bind:class="{ active: currentTab == 2}"></span>
        </div>
      </b-container>
    </div>
  </b-modal>
</template>

<script>
import server from '../../api/server.vue'

export default {
  name: 'AddKanbanBeModal',
  data() {
    const now = new Date()
    const today = now.getFullYear()+'-'+(now.getMonth()+1)+'-'+now.getDate()
    return {
      displayTab : true,
      loading: false,
        form:{
        plant: '',
        case_type: '',
        case_line:'',
        customer: '',
        command_type: null,
        command_date: today,
        domain: null,
        descriptif: '',
        details: '',
        internal_customer: '',
        internal_supplier: '',
        daisy: '',
        estimated_workload: 0,
        delay_ask: 0, 
        selectedType: 'kanban',
      }, 
      command_type_options: [
        { value: null, text: 'Sélectionner une option'},
        { value: 'Pré-étude', text: 'Pré étude'},
        { value: 'Commande', text: 'Commande'},
        { value: 'Livrable', text: 'Livrable'},
        { value: 'Opportunité', text: 'Opportunité'},
        { value: 'Trading', text: 'Trading'}
      ], 
      domain_options: [
        { value: null, text: 'Sélectionner une option'},
        { value: 'Customer Care', text: 'Customer care'},
        { value: 'Etude', text: 'Etude'},
        { value: 'Supply chain', text: 'Supply Chain'},
        { value: 'Site', text: 'Site'},
        { value: 'Marketing', text: 'Marketing'},
        { value: 'HR', text: 'RH'},
        { value: 'RSE', text: 'RSE'},
        { value: 'Comptabilité', text: 'Comptabilité'}
      ],
      currentTab: 1,
      nbFormParts: 2,
      // selectedType: 'kanban',
      options: ['kanban', 'kanban interne', 'customer care'], 
    }
  },
  watch: {
  },
  computed: {
  },
  methods: {
    versionKanbanCommerce (versionKanban) {
      this.displayTab = false
      const now = new Date()
      this.form.plant= versionKanban.plant
      this.form.case_type= versionKanban.case_type
      if ((parseInt(versionKanban.reference.substr(8, 10), 10) + 1).toString().length == 2) {
        this.form.case_line = "0" + (parseInt(versionKanban.reference.substr(8, 10), 10) + 1).toString()
      } else if ((parseInt(versionKanban.reference.substr(8, 10), 10) + 1).toString().length == 1) {
        this.form.case_line = "00" + (parseInt(versionKanban.reference.substr(8, 10), 10) + 1).toString()
      } else {
        this.form.case_line = (parseInt(versionKanban.reference.substr(8, 10), 10) + 1).toString()
      }
      this.form.customer = versionKanban.customer
      this.form.command_type = 'Opportunité'
      this.form.command_date = now.getFullYear()+'-'+(now.getMonth()+1)+'-'+now.getDate()
      this.form.domain = 'Customer Care'
      this.form.descriptif= versionKanban.descriptif
      this.form.details = versionKanban.details
      this.form.internal_customer = versionKanban.internal_customer
      this.form.internal_supplier = versionKanban.internal_supplier
      this.form.daisy = versionKanban.daisy
      this.form.estimated_workload = versionKanban.estimated_workload
      this.form.delay_ask = versionKanban.delay_ask
      this.form.selectedType= 'kanban'
    },
    formatter(value) {
      return value.toUpperCase()
    },
    isEmpty (value) {
      return _.isEmpty(value)
    },
    hideModal () {
      this.$refs['add-kanban-be-modal'].hide()
    },
    showModal () {
      this.$refs['add-kanban-be-modal'].show()
    },
    save () {
      this.loading = true
      this.form.case_type = this.form.case_type.replace(/\s/g, '')
      if (this.checkDate ()) {
        server.addKanbanBe(this.form).then(res => {
          this.$toasted.success('Carte kanban crée!')
          this.$emit('saved')
          this.hideModal()
          this.loading = false
          this.displayTab = true
          this.cleanForm()
          this.currentTab = 1
        }).catch((error) => {
          this.$toasted.error(`Mince ! Une erreur <br> ${error}`)
        })
      }
      else {
        this.$toasted.error('Vérifier les champs et la cohérence des dates')
      }
    },
    saveAndDoItAgain () {
      this.loading = true
      if (this.checkDate()){
        server.addKanbanBe(this.form).then(res => {
          this.$toasted.success('Carte kanban crée!')
          this.loading = false
          this.cleanToDoAgain()
          this.currentTab = 1
        }).catch((error) => {
          this.$toasted.error(`Mince ! Une erreur <br> ${error}`)
        })
      }
      else {
        this.$toasted.error('Vérifier la cohérence des dates')
      }
    },
    cleanForm () {
      const now = new Date()
      this.form.plant= ''
      this.form.case_type= ''
      this.form.case_line= ''
      this.form.customer= ''
      this.form.command_type= null
      this.form.command_date= now.getFullYear()+'-'+(now.getMonth()+1)+'-'+now.getDate()
      this.form.domain= null
      this.form.descriptif= ''
      this.form.details= ''
      this.form.internal_customer= ''
      this.form.internal_supplier= ''
      this.form.daisy= ''
      this.form.estimated_workload= 0
      this.form.delay_ask= 0
      this.form.selectedType= 'kanban'

    },
    cleanToDoAgain() {
      this.form.descriptif = ''
      this.form.details = ''
      this.form.internal_supplier = ''
      this.form.daisy = ''
      this.form.estimated_workload = 0.00
      this.form.delay_ask = 0
    },
    checkDate () {
      if (this.form.command_date && this.form.delay_ask){
        if (this.form.command_date > this.form.delay_ask) {
          return false
        } else {
          return true
        }
      }
      else {
        return false
      }
    },
    nextTab () {
      this.currentTab = this.currentTab + 1
    },
    prevTab (){
      this.currentTab = this.currentTab - 1
    },
    typeChanged (newType) {
      if (newType === 'kanban') {
        this.form.case_type = ''
        this.form.case_line = ''
        this.form.domain = null
      }
      else {
        this.form.case_type = ''
        this.form.case_line = '000'
        this.form.domain = 'Customer Care'
      }
    },
  },
  mounted: function() {
  },
};
</script>

<style>
input.invalid {
  background-color: #ffdddd;
}

select.invalid {
  background-color: #ffdddd;
}


.step {
  height: 15px;
  width: 15px;
  margin: 0 2px;
  background-color: #bbbbbb;
  border: none;
  border-radius: 50%;
  display: inline-block;
  opacity: 0.5;
}

.step.active {
  opacity: 1;
}

.step.finish {
  background-color: #4CAF50;
}

</style>


// WEBPACK FOOTER //
// src/components/modal/AddKanbanBeModal.vue